import { yupResolver } from "@hookform/resolvers/yup";
import React, { useCallback, useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { AddTrainingTypeSchema } from "../../../utils/mainTabs/manage/createTrainingTypeSchema";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Common/Button/Button";
import Input from "../../Common/Input/Input";
import {
  addTrainingTypeActionHandler,
  getTrainingTypesActionHandler,
  isTrainingTypeExistsActionHandler,
} from "../../../store/actions/actionHandlers/manageActionHandler";
import classes from "./AddTrainingTypeForm.module.scss";
import { errorTypes } from "../../../utils/errorTypes";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { FormattedMessage, injectIntl } from "react-intl";

const AddTrainingTypeForm = ({
  handleAddTrainingTypeModal,
  setTrainingTypes,
  setValue,
  intl
}) => {
  const dispatch = useDispatch();
  const manageState = useSelector((state) => state.manageReducer);
  const { addTrainingTypeLoader } = manageState;
  const commonState = useSelector((state) => state.commonReducer);
  const { colors } = commonState;

  const [isAddTrainingNameExists, setIsAddTrainingNameExists] = useState(null);
  const [addTrainingNameExistsLoader, setAddTrainingNameExistsLoader] =
    useState(false);

  const addTrainingTypeMethods = useForm({
    defaultValues: { AddTrainingType: "" },
    resolver: yupResolver(AddTrainingTypeSchema),
    mode: "onChange",
  });

  const {
    handleSubmit: addTrainingTypeHandleSubmit,
    reset: addTrainingTypeReset,
    formState: {
      isValid: isAddTrainingTypeValid,
      errors: addTrainingTypeErrors,
    },
    setFocus,
  } = addTrainingTypeMethods;

  useEffect(() => {
    setFocus("AddTrainingType");
  }, [setFocus]);

  const handleAddTrainingNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value;
      if (val) {
        if (/^[a-zA-Z0-9:_@?#|'`\]\[ ]*$/.test(val)) {
          setAddTrainingNameExistsLoader(true);
          dispatch(isTrainingTypeExistsActionHandler(val)).then((response) => {
            if (response && response.status === 200) {
              setAddTrainingNameExistsLoader(false);
              if (response.data) {
                setIsAddTrainingNameExists(true);
              } else {
                setIsAddTrainingNameExists(false);
              }
            }
          });
        }
      } else {
        setIsAddTrainingNameExists(false);
      }
    },
    [dispatch, setIsAddTrainingNameExists]
  );

  //edit training type logic
  const onAddSubmit = (data) => {
    dispatch(addTrainingTypeActionHandler(data.AddTrainingType, 0)).then(
      (isAdded) => {
        if (isAdded) {
          dispatch(
            setErrorHandler(
              errorTypes.SUCCESS,
              `Training Type ${data.AddTrainingType} created successfully`
            )
          );
          setTrainingTypes([]);
          dispatch(
            getTrainingTypesActionHandler(
              "",
              "",
              "",
              setTrainingTypes,
              () => {},
              () => {}
            )
          ).then((result) => {
            const id = result?.find(
              (type) => type.Name === data.AddTrainingType
            )?.TypeId;
            setValue("TrainingType", [
              { Name: data.AddTrainingType, TypeId: id },
            ]);
            setValue("TagSearch-TrainingType", "");
            addTrainingTypeReset();
            handleAddTrainingTypeModal();
          });
        }
      }
    );
  };

  return (
    <FormProvider {...addTrainingTypeMethods}>
      <form
        className={classes.addTrainingType__addModal}
        onSubmit={addTrainingTypeHandleSubmit(onAddSubmit)}
      >
        <div className={classes.addTrainingType__addModal__addField}>
          <Input
            // label={"Name"}
            direction="row"
            name={"AddTrainingType"}
            placeholder={intl.formatMessage({
              id: `ENTER_TRAINING_TYPE`,
            })}
            height="5"
            width="30"
            gap="0"
            onChange={(e) => handleAddTrainingNameExists(e)}
            loading={addTrainingNameExistsLoader}
          />
          {addTrainingTypeErrors?.AddTrainingType?.message ? (
            <div className={classes.addTrainingType__addModal__addField__error}>
              {addTrainingTypeErrors?.AddTrainingType?.message}
            </div>
          ) : (
            isAddTrainingNameExists && (
              <div
                className={classes.addTrainingType__addModal__addField__error}
              >
                Training type already exist
              </div>
            )
          )}
        </div>
        <div className={classes.addTrainingType__addModal__footer}>
          <Button
            label={<FormattedMessage id="ADD_TRAINING_BTN" />}
            backgroundColor={addTrainingTypeLoader ? undefined : colors.theme}
            borderRadius="0.7"
            color={addTrainingTypeLoader ? undefined : "#fff"}
            disabled={!isAddTrainingTypeValid || isAddTrainingNameExists}
            width="14.5"
            height="4.9"
            type="submit"
            loading={addTrainingTypeLoader}
          />
          <div
            className={classes.addTrainingType__addModal__footer__button2}
            onClick={handleAddTrainingTypeModal}
          >
            <FormattedMessage id="USERGRP_CANCELBTN_TEXT" />
          </div>
        </div>
      </form>
    </FormProvider>
  );
};

export default React.memo(injectIntl(AddTrainingTypeForm));
